// extracted by mini-css-extract-plugin
export default {"root":"styles_root__6xQPm","wrapper":"styles_wrapper__TxaDE","headBlock":"styles_headBlock__NDl7m","aboveTitle":"styles_aboveTitle__yO3o4","title":"styles_title__4VBw-"};